export default __webpack_public_path__ + "static/dont-leading-visual-5b25f168c0454e6a40361380c2e8c1d9.png";